class AssetDefer {

  registered = {};
  requirements = [];
  cache = {};

  constructor() {
    this.requirements = this.getMetaPaths();
  }

  css(path, selector, options, ratio, cb) {
    this.add(() => {
      let head = document.getElementsByTagName('HEAD'),
        link = document.createElement('link');

      link.rel = 'stylesheet';
      link.href = this.lookup(path);
      link.onload = cb || (() => {
      })

      head[0].appendChild(link);
    }, path, selector, options, ratio, cb);

    return this;
  }

  js(path, selector, options, ratio, cb) {
    this.add(() => {
      let paths = path.split(',');

      paths.forEach(s => {
        let script = document.createElement('script');

        script.src = this.lookup(s);
        script.type = 'text/javascript';
        script.onload = cb || (() => {
        })

        document.body.appendChild(script);
      })
    }, path, selector, options, ratio, cb);

    return this;
  }

  add(op, path, selector, options = {threshold: 1}, ratio = 1, cb = () => null) {
    if (!('IntersectionObserver' in window)) {
      !this.isRegistered(path) && op();
      this.register(path);
      //cb();

      return this;
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio < ratio) return;

        if (!this.isRegistered(path)) {
          op();
          this.register(path);
        }

        //cb();

        observer.unobserve(entry.target);
      });
    }, options);

    let elements = selector;

    if (typeof selector === 'string') {
      elements = document.querySelectorAll(selector);
    }

    elements.forEach(el => observer.observe(el));

    return this;
  }

  lookup(path) {
    if (!(path in this.cache)) {
      this.cache[path] = path;

      for (let i = 0; i < this.requirements.length; i++) {
        if (this.requirements[i].indexOf(path) < 0) continue;

        this.cache[path] = this.requirements[i];
        break;
      }
    }

    return this.cache[path];
  }

  register(path) {
    this.registered[path] = true;

    return this;
  }

  isRegistered(path) {
    return path in this.registered;
  }

  getMetaPaths() {
    return [...document.querySelectorAll('meta[name="requirements:register"]')].map(meta => meta.content);
  }
}

export default AssetDefer;
